isFlattenable